import styled from "styled-components";

export const GameJackpotBarLabelDefaultBox = styled.span`
    font-size: 1.1rem;
    @media ${({theme}) => theme.mediaQuery.mAndAbove} {
        font-size: 1.2rem;
    }
    ${({theme}) => theme.font.presets.medium};
    line-height: 12px;
    color:  ${({theme}) => theme.colors.textLight};
`;